/**
 * Objectで定義された値をSelectOptions用のvalue, labelのObject配列に変換する
 * @param obj { 1: 'a', 2: 'b' }
 * @returns [{ value: 1, label: 'a' }, { value: 2, label: 'b' }]
 */
export const objectToAtomsConsumerSelectOptions = (obj: Record<string, string>) => {
  return Object.entries(obj).map(([key, value]) => ({
    value: key,
    label: value,
  }))
}
